var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartReactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.78 101.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4caf50;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.24px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.78,55.78l-27.34,27.29-27.33-27.29c-7.6-7.59-7.72-19.9-.27-27.36,2.55-2.55,5.67-4.22,8.99-4.99,6.35-1.49,13.37.28,18.36,5.26l.25.25,4.43,4.43,4.7-4.68c2.71-2.7,6.01-4.46,9.47-5.26,3.32.78,6.44,2.44,9,4.99,7.45,7.45,7.32,19.76-.27,27.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.67,55.78l-31.79,31.74-4.44-4.44,27.34-27.29c7.59-7.59,7.72-19.9.27-27.36-2.56-2.55-5.69-4.22-9-4.99,6.28-1.45,13.09.2,17.89,4.99,7.45,7.45,7.32,19.76-.27,27.36Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.41,32.22c-1.28.5-2.47,1.26-3.5,2.29-4.12,4.12-4,10.94.27,15.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.67,55.79c7.6-7.6,7.72-19.91.27-27.36-7.45-7.44-19.76-7.32-27.36.27l-4.71,4.68-4.68-4.68c-7.6-7.6-19.91-7.71-27.35-.27-7.45,7.45-7.33,19.76.27,27.36l31.77,31.73,31.79-31.73Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartReactionIcon);
export default __webpack_public_path__ + "static/media/heart-reaction-icon.909fba98348829e69107ebb5ffa281ee.svg";
export { ForwardRef as ReactComponent };